import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, Subscription, switchMap, tap } from 'rxjs';

import { HeaderComponent } from "./shared/components/header/header.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { CmsStoreRepository } from './shared/repositories/cms-data.repository';
import { SkipperComponent } from "./shared/components/skipper/skipper.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [RouterOutlet, FooterComponent, HeaderComponent, SkipperComponent]
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'web-patient-frontend';

    private subscription = new Subscription();

    constructor(
        private router: Router,
        private translationUpdateService: CmsStoreRepository,
        private cmsService: CmsStoreRepository,
    ) { }

    ngOnInit() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.checkForCmsDataUpdates();
            });
    }

    checkForCmsDataUpdates(): void {
        // left for later use
        // this.subscription.add(
        //     this.translationUpdateService.getData$().pipe(
        //         switchMap(translation => this.cmsService.data$.pipe(
        //             tap(data => {
        //                 if (translation !== data) {
        //                     this.cmsService.setTranslationData(translation);
        //                 }
        //             })
        //         ))
        //     ).subscribe()
        // )
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }
}
